import React, {useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from '../../features/user';
import { useTranslation } from 'react-i18next';
import {checkValidToken} from "../../Helper"
import Frame from '../widgets/Frame';
import Background from '../widgets/Background';

import AppUrlListener from '../widgets/AppUrlListener';


export function Start() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    //const [searchParams] = useSearchParams();
    const dispatch = useDispatch();
    
    useEffect(() => {
        checkValidToken(navigate, dispatch);
        // eslint-disable-next-line  
    }, []);


    const handleLoginClick = (e) => {
        navigate("/login"); //navigate("/login", { replace: true });
    };

    const handleLoginProviderClick = (e) => {
        navigate("/provider-login");
    }; 


    return (
        <Frame>
            <div className='main main-start'>
                      {/* <AppUrlListener></AppUrlListener> */}
                <div className='main-body'>
                    <div className='left-main'></div>
                    <div className='right-main'>
                        <Background showClouds={true}>
                            <div className='right-main-inner'>
                                <div className='center-div'>
                                    <img className='start-logo' src='/images/logo_big.png' alt='' />
                                </div>
                                <div className='mt40 text-align-center font-18 color-550952'>{t("please_select_the_best_choice")}</div> 
                                <div className='mt20'><div className='shadow-button' onClick={(e) => handleLoginClick(e)}> {t("writers")} </div></div>
                                <div className='mt20 mb20'><div className='shadow-button' onClick={(e) => handleLoginProviderClick(e)}> {t("providers")} </div></div>
                            </div>
                        </Background>
                    </div>
                    <div className='left-main'>
                        {/* <img src='/images/side-image.png' className='content-logo' alt=''/> */}
                    </div>
                </div>
            </div>
        </Frame>
    );
}